export interface ComboDataDTO {
    id: number | null;
    name: string | null;
    isExternalId?: boolean;
}

export const defaultComboDataDTO:ComboDataDTO = {
    id: -1,
    name: ''
}

export const defaultAllComboDataDTO:ComboDataDTO = {
    id: -1,
    name: '<Todos>'
}

export const defaultSlashComboDataDTO:ComboDataDTO = {
    id: -1,
    name: ' - '
}